import {marketTime} from "./DateTimeUtil";
import {Moment} from "moment-timezone";

export class MarketUtil {

    public static marketIsOpen(): boolean {
        const now = marketTime();
        const isWeekend = now.isoWeekday() > 5;
        const isEarly = now.hour() < 10 || (now.hour() === 10 && now.minute() < 20);
        const isLate = now.hour() > 15;
        return !isWeekend && !isEarly && !isLate;
    }

    /* Has some extra time padding around the actual market hours */
    public static extendedMarketIsOpen(): boolean {
        const now = marketTime();
        const isWeekend = now.isoWeekday() > 5;
        const isEarly = now.hour() < 9;
        const isLate = now.hour() > 16;
        return !isWeekend && !isEarly && !isLate;
    }
}

export const PriceUpdateIntervalSeconds = 15;
export const PriceUpdateInterval = PriceUpdateIntervalSeconds * 1000;
export const OutsideHoursUpdateIntervalSeconds = 60;
export const OutsideHoursUpdateInterval = OutsideHoursUpdateIntervalSeconds * 1000;